/**
 * stripe.js — Gestione Stripe Elements e creazione PaymentMethod.
 * Mirror di createPayment() / payReservation() in pay_page_widget.dart.
 * Dipende da: env.js, state.js
 */
const StripeController = {

    stripe:      null,
    cardElement: null,
    initialized: false,

    // Inizializza Stripe Elements nel container #stripe-card-element
    init() {
        if (this.initialized) return;
        if (typeof Stripe === 'undefined') {
            console.warn('[Stripe] Stripe.js non ancora caricato');
            return;
        }
        const container = document.getElementById('stripe-card-element');
        if (!container) return;

        this.stripe = Stripe(ENV.stripeKey);
        const elements = this.stripe.elements();

        this.cardElement = elements.create('card', {
            style: {
                base: {
                    fontFamily: "'Inter', sans-serif",
                    fontSize:   '16px',
                    color:      '#0e1f3b',
                    '::placeholder': { color: '#6c757d' },
                },
                invalid: { color: '#dc3545' },
            },
        });

        this.cardElement.mount('#stripe-card-element');

        this.cardElement.on('change', ({ error }) => {
            const errEl = document.getElementById('stripe-card-errors');
            if (errEl) errEl.textContent = error ? error.message : '';
        });

        this.initialized = true;
    },

    // Crea un PaymentMethod dalla carta inserita e restituisce il suo ID
    async createPaymentMethod() {
        if (!this.stripe || !this.cardElement)
            throw new Error('Stripe non inizializzato. Ricarica la pagina e riprova.');

        const c = BookingState.client;
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: {
                name:    `${c.name} ${c.lastname}`.trim(),
                email:   c.email,
                phone:   c.phone,
                address: { line1: c.address, country: 'IT' },
            },
        });

        if (error) throw new Error(error.message);
        return { id: paymentMethod.id, type: 'card' };
    },
};

// Carica Stripe.js dinamicamente (non richiede modifica all'HTML)
function loadStripeJS(cb) {
    if (typeof Stripe !== 'undefined') { cb(); return; }
    const s   = document.createElement('script');
    s.src     = 'https://js.stripe.com/v3/';
    s.onload  = cb;
    s.onerror = () => console.error('[Stripe] Impossibile caricare Stripe.js');
    document.head.appendChild(s);
}
